import { render } from "./SearchModalTrendingCard.vue?vue&type=template&id=43a8554f"
import script from "./SearchModalTrendingCard.vue?vue&type=script&lang=js"
export * from "./SearchModalTrendingCard.vue?vue&type=script&lang=js"

import "./SearchModalTrendingCard.vue?vue&type=style&index=0&id=43a8554f&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__